import { environment } from "@env/environment";
const HASH = environment.VIM_COOKIES_HASH;

export const LocalStorage = {
  SESSION_TOKEN: HASH + "_LOCAL_1",
};
